import Interrupters from '@ulta/core/components/Interrupters/Interrupters';

export default Interrupters;